import { Box } from "@mui/material"
import { BreadCrumb, SnackSimple } from "../../../../components"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import { TabsItemFilesDeatil } from "../../utils/enums/tabs"
import { useTranslation } from "react-i18next"
import { ListTabItem } from "../../../../components/customeTab/types"
import { useState } from "react"
import { useStyles } from "./styles"
import { FileDetail } from "./components/file"
import { PermissionFile } from "./components/permissions"
import SimpleModal from "../../../../components/modal/simpleModal"
import { useNavigate } from "react-router-dom"
import { useBody } from "./body"
import Loader from "../../../../components/loader"


export const FileManagerDetail = () => {

    const { t } = useTranslation()
    const styles = useStyles()

    const navigate = useNavigate()

    const tabs: ListTabItem[] = [
        {
            id: TabsItemFilesDeatil.FILE,
            label: t('filesManager.tabs.file'),
            value: TabsItemFilesDeatil.FILE
        },
        {
            id: TabsItemFilesDeatil.PERMISSIONS,
            label: t('filesManager.tabs.permissions'),
            value: TabsItemFilesDeatil.PERMISSIONS
        },
    ]

    const [tabValue, setTabValue] = useState(TabsItemFilesDeatil.FILE);

    const changeTab = ({ value }: { value: TabsItemFilesDeatil }) => {
        setTabValue(value)
    }

    const goBackToList = () => {
        navigate('/dashboard/filesManager/main');
    }

    const body = useBody()

    return (
        <Box sx={styles.container}>
            <BreadCrumb
                replaceLabels={{ detailEdit: 'filesManagerDetail' }}
            />

            <CustomeTab
                listTab={tabs}
                value={tabValue}
                justifyContent="start"
                tabList={{ onChange: (_, value) => { changeTab({ value }) } }}
            >
                <CustomePanel value={TabsItemFilesDeatil.FILE}>
                    {body.loadingDetail ?
                        <Loader />
                        :
                        <FileDetail
                            goBackToList={goBackToList}
                            data={body.data}
                            errors={body.errors}
                            file={body.file}
                            setData={body.setData}
                            setErrors={body.setErrors}
                            setFile={body.setFile}
                            status={body.statusFile}
                            solictedUser={body.solictedUser}
                            isEdit={false}
                            backToDetail={false}
                            userCreator={body.userCreator}
                            showOptions={body.showOptions}
                            activateOrDesactivate={body.activateOrDesactivate}
                            deleteFile={body.deleteFile}
                            canDownload={body.canDownload}
                            canSee={body.canSee}
                            keyFile={body.keyFile}
                            column={[]}
                            inputUser={{}}
                            searchUsersSolicited={async() => {}}
                            handleShowTable={()=>{}}
                            showTable={false}
                        />
                    }
                </CustomePanel>

                <CustomePanel value={TabsItemFilesDeatil.PERMISSIONS}>
                    <PermissionFile totalPages={body.totalPages} isLoading={body.isLoading} row={body.row} filterPermissions={body.filterPermissions} />
                </CustomePanel>
            </CustomeTab>


            <SimpleModal
                open={!!body.modal.open}
                next={body.modal.confirm}
                back={body.closeModalIndex}
                close={body.closeModalIndex}
                description={body.modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={body.modal.title}
                loadingButton={false}
            />

            <SnackSimple open={body.snackbarOpen.open} close={body.closeSnackBarOpen} message={body.snackbarOpen.message} type={body.snackbarOpen.type} />


        </Box>
    )
}